export default {
    your_invoice: 'វិក្កយបត្រ',
    billing_to: 'វិក័យប័ត្រទៅកាន់',
    invoice: 'វិក័យប័ត្រ#',
    customers_id: 'លេខសម្គាល់អតិថិជន',
    description: 'បរិយាយ',
    qty: 'បរិមាណ',
    unit_price: 'តម្លៃ​ឯកតា',
    total_invoice: 'សរុប',
    invoice_footer_thank: 'សូមអរគុណចំពោះការឧបត្ថម្ភរបស់អ្នក!',
    invoice_footer_text: {
        1: 'អ្នកផ្តល់សេវា cloud & hosting ដ៏ល្អបំផុត',
        2: 'ចូលទៅកាន់គេហទំព័រ www.1byte.com សម្រាប់ព័ត៌មានបន្ថែមអំពីផលិតផល និងការផ្សព្វផ្សាយរបស់យើង',
        notice: 'Notice to Thai legal entities: Please send the {whtPercent}% Withholding Tax Certificate to {noticeEmail}',
    },
    terms_text: 'ខ្ញុំបានអាននិងយល់ព្រមនឹង',
    terms_and_conditions: 'លក្ខខណ្ឌ',
    due_upon_receipt: 'ទទួលបានវិក័យប័ត្រ ',
    date: 'កាលបរិច្ឆេទ',
    terms: 'ល័ក្ខខ័ណ្ឌ',
    amount: 'ចំនួន',
    total: 'សរុប',
    invoice_id: 'វិក័យប័ត្រ#',
    customer_id: 'លេខសម្គាល់អតិថិជន',
    discount: 'បញ្ចុះតម្លៃ',
    actionRegister: 'ចុះឈ្មោះ',
    actionRenew: 'ការបន្ត',
    actionReactivate: 'មានសកម្មឡើងវិញ',
    actionTransfer: 'ការផ្ទេ',
    actionPurchase: 'ការទិញ',
    actionUpgrade: 'តំឡើង',
    actionBackup: 'បម្រុងទុក',
    zip_code: 'លេខ​កូដ​តំបន់: {value}',
    zip_code_invoice: 'លេខ​កូដ​តំបន់ {value}',
    year: 'ឆ្នាំ',
    years: 'ឆ្នាំ',
    months: 'ខែ',
    month: 'ខែ',
    bank_info: {
        title: 'ដើម្បីទូទាត់សូមដាក់ការទូទាត់របស់អ្នកដូចខាងក្រោម:',
        beneficiary: 'អ្នកទទួលផល:',
        bank: 'ធនាគារ:',
        account_no: 'លេខគណនី:',
        swift_code: 'លេខកូដ SWIFT:',
    },
    amount_due: 'ចំនួនទឹកប្រាក់ដែលត្រូវបង់',
};
